import React from 'react'
import yn from 'yn'
import PropTypes from 'prop-types'

if (yn(process.env.REACT_APP_COMPONENT_HERO)) {
  require('./styles.scss')
}

const Hero = ({ content }) => {
  const heroImage = content?.hero?.path
  const heroCaption = content?.hero?.caption
  const heroDescription = content?.hero?.description

  return heroImage ? (
    <div className="hero" style={{ backgroundImage: `url(${heroImage})` }}>
      {heroCaption && <h2>{heroCaption}</h2>}
      <img
        className="u-remove-element"
        src={heroImage}
        alt={heroDescription ? heroDescription : 'Ferries Hero'}
      />
    </div>
  ) : null
}

Hero.propTypes = {
  content: PropTypes.shape().isRequired
}

export default Hero
